import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Teleport as _Teleport, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "collapsed-icon-wrap" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "28",
    height: "28",
    fill: "#fff"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "8",
      cy: "10",
      r: "1.2"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "10",
      r: "1.2"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "16",
      cy: "10",
      r: "1.2"
    })
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "notice-expanded"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hub-icon-circle" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "#1890ff"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "8",
      cy: "10",
      r: "1"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "10",
      r: "1"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "16",
      cy: "10",
      r: "1"
    })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "hub-item-label" }, "智能回复", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "hub-divider" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "个人待办", -1)
const _hoisted_9 = {
  key: 0,
  class: "notice-list"
}
const _hoisted_10 = { class: "info" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "hub-icon-circle hub-icon-bell" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "hub-item-label" }, "消息提醒", -1)
const _hoisted_15 = { class: "cs-header" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "cs-header-title" }, "智能客服", -1)
const _hoisted_17 = {
  key: 0,
  class: "cs-header-tip"
}
const _hoisted_18 = {
  key: 0,
  class: "cs-loading"
}
const _hoisted_19 = { class: "cs-avatar" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "cs-bubble" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "cs-time" }
const _hoisted_26 = {
  key: 1,
  class: "cs-msg cs-msg-system"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "cs-avatar" }, [
  /*#__PURE__*/_createElementVNode("span", null, "AI")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "cs-bubble" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cs-content cs-typing" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "cs-input-area" }
const _hoisted_31 = ["onKeydown", "disabled"]
const _hoisted_32 = ["disabled"]

import { InfoCircleOutlined, BellOutlined } from '@ant-design/icons-vue';
import { useDraggable, onClickOutside } from '@vueuse/core';
import { ref, watch, nextTick, onMounted } from 'vue';
import { NoticeItem, ChatMessage } from './Notice';
import { renderMarkdown } from '@/utils/markdown';
import 'animate.css';
import { OioButton } from '@kunlun/vue-ui-antd';

interface IProps {
  noticeList: NoticeItem[];
  show: boolean;
  hasNewNotice: boolean;
  total: number;
  jump: (item: NoticeItem) => void;
  // 智能客服相关
  chatVisible: boolean;
  chatMessages: ChatMessage[];
  chatLoading: boolean;
  chatSending: boolean;
  humanServiceUrl: string;
  openSmartChat: () => void;
  closeChat: () => void;
  sendChatMessage: (text: string) => void;
  openHumanService: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Notice',
  props: {
    noticeList: null,
    show: { type: Boolean },
    hasNewNotice: { type: Boolean },
    total: null,
    jump: null,
    chatVisible: { type: Boolean },
    chatMessages: null,
    chatLoading: { type: Boolean },
    chatSending: { type: Boolean },
    humanServiceUrl: null,
    openSmartChat: null,
    closeChat: null,
    sendChatMessage: null,
    openHumanService: null
  },
  setup(__props: any) {

const props = __props as { noticeList: NoticeItem[], show: boolean, hasNewNotice: boolean, total: number, jump: (item: NoticeItem) => void, chatVisible: boolean, chatMessages: ChatMessage[], chatLoading: boolean, chatSending: boolean, humanServiceUrl: string, openSmartChat: () => void, closeChat: () => void, sendChatMessage: (text: string) => void, openHumanService: () => void }



const el = ref<HTMLElement | null>(null);
const messagesRef = ref<HTMLElement | null>(null);
const hubExpanded = ref(false);
const noticeVisible = ref(false);
const chatInput = ref('');
const isDragged = ref(false);

// 保留原有的 useDraggable 定位逻辑
const draggable = useDraggable(el, {
  initialValue: { x: document.body.clientWidth - 128, y: document.body.clientHeight - 128 },
  onStart() {
    isDragged.value = false;
  },
  onMove(position) {
    isDragged.value = true;
    hubExpanded.value = false;
    noticeVisible.value = false;
    if (position.x < 0) position.x = 0;
    if (position.y < 0) position.y = 0;
    if (position.x > document.body.clientWidth - 70) position.x = document.body.clientWidth - 70;
    if (position.y > document.body.clientHeight - 70) position.y = document.body.clientHeight - 70;
  },
  onEnd() {
    // 没有拖拽移动且当前是收起状态 → 展开
    // 展开状态下的点击由子元素自身的 @click 处理，不在此干预
    if (!isDragged.value && !hubExpanded.value) {
      hubExpanded.value = true;
    }
  }
});
const { style } = draggable;

// 挂载后重新根据真实视口尺寸设置初始位置（setup 期间 body.clientHeight 可能为 0）
onMounted(() => {
  nextTick(() => {
    const vw = document.documentElement.clientWidth || window.innerWidth;
    const vh = document.documentElement.clientHeight || window.innerHeight;
    draggable.position.value = { x: vw - 128, y: vh - 128 };
  });
});

onClickOutside(el, () => {
  hubExpanded.value = false;
  noticeVisible.value = false;
});

const handleOpenSmartChat = () => {
  hubExpanded.value = false;
  noticeVisible.value = false;
  props.openSmartChat();
};

const handleClick = (item: NoticeItem) => {
  props.jump(item);
};

const handleSend = () => {
  const text = chatInput.value.trim();
  if (!text) return;
  props.sendChatMessage(text);
  chatInput.value = '';
};

const fmtTime = (time?: string) => {
  if (!time) return '';
  try {
    const d = new Date(time);
    return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  } catch {
    return '';
  }
};

// 消息列表自动滚底
watch(
  () => props.chatMessages,
  () => {
    nextTick(() => {
      if (messagesRef.value) {
        messagesRef.value.scrollTop = messagesRef.value.scrollHeight;
      }
    });
  },
  { deep: true }
);

// 新消息弹跳动画
const animateClassList = ['animate__animated', 'animate__bounce', 'animate__repeat-2'];
watch(
  () => props.hasNewNotice,
  (newVal) => {
    if (newVal && el.value) {
      el.value.classList.add(...animateClassList);
      setTimeout(() => {
        el.value?.classList.remove(...animateClassList);
      }, 2000);
    }
  }
);

// 展开 / 收拢状态完全交给 CSS transform 处理（参见 .notice-hub-root.is-expanded）
// 球位置仍由 useDraggable 控制；展开后 CSS 把根容器右下角锘点到球右下角 → 菜单向左上方展开

return (_ctx: any,_cache: any) => {
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "el",
          ref: el,
          style: _normalizeStyle(_unref(style)),
          class: "notice-hub-root"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["notice-collapsed", { 'is-hidden': hubExpanded.value }])
          }, _hoisted_2, 2),
          (hubExpanded.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "hub-item",
                  onClick: handleOpenSmartChat
                }, _hoisted_6),
                _hoisted_7,
                _createVNode(_component_a_popover, {
                  placement: "leftTop",
                  trigger: "click",
                  visible: noticeVisible.value,
                  "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((noticeVisible).value = $event))
                }, {
                  title: _withCtx(() => [
                    _hoisted_8
                  ]),
                  content: _withCtx(() => [
                    (__props.noticeList.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.noticeList, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "notice-item"
                            }, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_unref(InfoCircleOutlined), { style: {"color":"var(--oio-button-primary-background)","font-size":"16px","margin-right":"5px"} }),
                                _createElementVNode("span", {
                                  innerHTML: item.contentTemplate
                                }, null, 8, _hoisted_11)
                              ]),
                              _createVNode(_unref(OioButton), {
                                onClick: ($event: any) => (handleClick(item)),
                                type: "link"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("去处理")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_12, "无"))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "hub-item",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_unref(BellOutlined), { style: {"font-size":"18px","color":"#1890ff"} })
                      ]),
                      _hoisted_14,
                      (__props.total > 0)
                        ? (_openBlock(), _createBlock(_component_a_badge, {
                            key: 0,
                            count: __props.total,
                            "overflow-count": 99,
                            class: "hub-badge"
                          }, null, 8, ["count"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            (__props.chatVisible)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "smart-cs-dialog",
                  onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    (__props.humanServiceUrl)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _createTextVNode(" 若需省区客服直接对接，可"),
                          _createElementVNode("a", {
                            class: "cs-human-link",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (__props.openHumanService && __props.openHumanService(...args)))
                          }, "点击人工客服")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "cs-close-btn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (__props.closeChat && __props.closeChat(...args)))
                    }, "×")
                  ]),
                  _createElementVNode("div", {
                    class: "cs-messages",
                    ref_key: "messagesRef",
                    ref: messagesRef
                  }, [
                    (__props.chatLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, "加载中..."))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.chatMessages, (msg, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: _normalizeClass(["cs-msg", {
          'cs-msg-customer': msg.senderType === 'CUSTOMER',
          'cs-msg-ai': msg.senderType === 'AI',
          'cs-msg-system': msg.senderType === 'SYSTEM'
        }])
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          (msg.senderType === 'CUSTOMER')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "我"))
                            : (msg.senderType === 'AI')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "AI"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_22, "ⓘ"))
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", {
                            class: "cs-content",
                            innerHTML: _unref(renderMarkdown)(msg.messageContent)
                          }, null, 8, _hoisted_24),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(fmtTime(msg.sendTime)), 1)
                        ])
                      ], 2))
                    }), 128)),
                    (__props.chatSending)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
                      : _createCommentVNode("", true)
                  ], 512),
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((chatInput).value = $event)),
                      class: "cs-input",
                      placeholder: "请输入您的问题...",
                      onKeydown: _withKeys(_withModifiers(handleSend, ["exact","prevent"]), ["enter"]),
                      disabled: __props.chatSending,
                      rows: "2"
                    }, null, 40, _hoisted_31), [
                      [_vModelText, chatInput.value]
                    ]),
                    _createElementVNode("button", {
                      class: "cs-send-btn",
                      onClick: handleSend,
                      disabled: __props.chatSending || !chatInput.value.trim()
                    }, "发送", 8, _hoisted_32)
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ]))
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})